import { meta } from "../src/landingPage/datasets/meta";
import { NextHead } from "../src/landingPage/layouts/LayoutComponents/NextHead";

const PrivacyPage = () => {
  return (
    <>
      <NextHead
        currentPath="/privacy-policy"
        title={meta.accessibility.title}
        description={meta.accessibility.description}
      />
      <section className="legal-background">
        <section className="section-layout">
          <section className="legal-main legal-main_paper">
            <section className="legal-main legal-main_paper">
              <h1>Demyst Data Accessibility Policy</h1>

              <h2>Purpose</h2>

              <p>
                At Demyst Data, we are committed to making our platform accessible to all users,
                regardless of their abilities. This Accessibility Policy outlines the measures we
                have put in place to ensure that our service is inclusive and usable by as many
                people as possible.
              </p>
              <h2>Note Regarding Platform Functionality</h2>
              <p>When using the Demyst Platform, there are two alternate ways to interact:</p>
              <ol
                style={{
                  paddingLeft: "20px",
                  listStyle: "auto",
                }}
              >
                <li>Via the web interface through a modern browser</li>
                <li>
                  Via the Demyst Platform’s application programming interface (API) which provides
                </li>
              </ol>
              <p>
                information in a machine-readable format for integration with other applications.
                Where support below is indicated below as "Supports with exceptions", such a
                qualification applies to the web interface only; interactions may be accomplished
                through the Demyst Platform API.
              </p>
              <h2>Scope</h2>
              <p>
                This policy applies to all aspects of our platform, including but not limited to the
                user interface, documentation, customer support, and third-party integrations.
              </p>
              <h2>Design Philosophy and Standards Compliance</h2>
              <p>
                We consider compliance with applicable compliance standards as we design our
                platform and on an ongoing basis. Specifically, we strive to meet Web Content
                Accessibility Guidelines (WCAG) Level AA compliance as set forth by the Web Content
                Accessibility Guidelines (WCAG) 2.1 and we make every effort to conform to the
                Americans with Disabilities Act (ADA) standards.
              </p>
              <h2>Features and Functions</h2>
              <p>
                Features and functions we have added to our platform to support accessibility
                include, but are not limited to, the following:
              </p>
              <ol
                style={{
                  paddingLeft: "20px",
                  listStyle: "auto",
                }}
              >
                <li>
                  Keyboard Navigation: Our platform is navigable via keyboard and keyboard focus has
                  a noticeable outline.
                </li>
                <li>
                  Screen Reader Compatibility: We have worked to optimize our platform for screen
                  reader software; links, buttons, and page landmarks are tagged for assistive
                  technology{" "}
                </li>
                <li>
                  Contrast and Color Options: We ensure foreground and background colors have
                  sufficient contrast and that letter spacing and font sizes support readability
                </li>
                <li>
                  Alternative Text: Non-text content, such as images and icons, are provided with
                  appropriate alternative text to ensure screen reader users can understand their
                  context.
                </li>
                <li>
                  Clear Language: We use clear and simple language to make our content easy to
                  understand for a wide range of users.
                </li>
                <li>
                  Meaningful Sequence: Our platform follows a meaningful and consistent sequence for
                  content presentation.
                </li>
              </ol>
              <h2>Testing and Ongoing Efforts</h2>
              <ol>
                <li>
                  Manual Audits: Our accessibility team conducts regular manual audits to identify
                  and fix accessibility issues.
                </li>
                <li>
                  User Feedback: We actively seek and consider feedback from users to improve
                  accessibility.
                </li>
                <li>
                  Employee Training: Our team members involved in content creation, design, and
                  development receive training on web accessibility best practices.
                </li>
              </ol>
              <h2>Reporting Issues and Feedback</h2>
              <p>
                If you encounter any accessibility issues or have suggestions for improvement,
                please contact our Accessibility Team at accessibility@demystdata.com or call +1
                808-400-8470.
              </p>
              <h2>Policy Review and Updates</h2>
              <p>
                This policy will be reviewed at least annually and updated as necessary to reflect
                changes in accessibility standards and feedback from users.
              </p>
              <hr />
              <p>Date of Last Revision: 9/1/2023</p>
            </section>
          </section>
        </section>
      </section>
    </>
  );
};

export const getStaticProps = () => {
  return {
    props: {
      wrapper: "MarketingWrapper",
    },
  };
};

export default PrivacyPage;
